import { environment } from '@upkey-platform/core/core-shared'

export const MYJOBS_API_URL = {
  getPaginatedJobs: `${environment.apiUrl}/jobs`,
  createJob: `${environment.apiUrl}/jobs`,
  getOneJob: (id: string) => `${environment.apiUrl}/jobs/${id}`,
  getJobScore: (id: string) => `${environment.apiUrl}/jobs/${id}/score`
}
